import { React, useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"; // For the left arrow icon

const CbdcRequest = ({ onBackClick, merchantId }) => {
  const [merchantIdError, setMerchantIdError] = useState(false);

  const handleRequestCbdc = () => {
    // Check if merchantId is empty
    if (!merchantId) {
      setMerchantIdError(true);
      return; // Prevent sending the email if validation fails
    } else {
      setMerchantIdError(false);
    }

    // Pre-fill the email with user data
    const emailBody = `
      Kalp Wallet ID: ${merchantId}
    `;

    // Create a mailto link with subject and body
    const mailToLink = `mailto:request.cbdc@bimtech.ac.in?subject=Request for CBDC&body=${encodeURIComponent(
      emailBody
    )}`;

    // Open default email client (Google Mail will be prompted if set as the default)
    window.location.href = mailToLink;
  };

  return (
    <Box
      sx={{
        padding: "40px",
        maxWidth: "500px",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      {/* Back Button and Title on the same line */}
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: "30px" }}>
        <Button
          variant="text"
          onClick={onBackClick}
          sx={{
            color: "#6a00f4",
            textTransform: "none",
            minWidth: "fit-content",
            marginRight: "10px", // Adjust spacing between arrow and title
            padding: 0,
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
        </Button>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          CBDC Token Request
        </Typography>
      </Box>

      {/* Input Fields */}
      <Box component="form">
        <TextField
          placeholder="Enter User's Address" // Removed label, replaced with placeholder
          variant="outlined"
          fullWidth
          value={merchantId}
          error={merchantIdError}
          helperText={merchantIdError ? "User address is required" : ""}
          sx={{
            marginBottom: "20px",
            backgroundColor: "transparent",
            borderRadius: "15px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              height: "50px",
              backgroundColor: "white",
            },
            "& .MuiFormHelperText-root": {
              backgroundColor: "transparent", // Make the error text background transparent
              marginLeft: 0,
              padding: 0,
            },
          }}
          InputProps={{
            readOnly: true,
            sx: { borderRadius: "12px", height: "50px" },
          }}
        />

        {/* Send Request Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleRequestCbdc}
          sx={{
            backgroundColor: "#6200ea",
            color: "#fff",
            padding: "15px 0",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#4b00c7",
            },
          }}
        >
          Send Request
        </Button>
      </Box>
    </Box>
  );
};

export default CbdcRequest;
